import { sendGAEvent } from '@next/third-parties/google';

const googleEventLogin = (): any => {
  return sendGAEvent('event', 'login');
};
export default googleEventLogin;
